module.exports = __webpack_public_path__ + "img/chocolate-chip-cookie-bars.0933f04f.jpg";